<template>
    <div>
        <v-card class="ma-3 pa-3">
            <v-btn small @click="goBack" class="mb-3">
                <v-icon small>mdi-arrow-left</v-icon>
                Back to Growth Phases
            </v-btn>
            <h3 v-if="selectedGrowthPhase">{{ selectedGrowthPhase.phase_type }} - Items</h3>
        </v-card>

        <create-growth-phase-item-card :growthPhaseId="phaseId" />
        <growth-phase-items :growthPhaseId="phaseId" />
    </div>
</template>

<script>
import { mapState } from 'vuex'
import CreateGrowthPhaseItemCard from '../../components/culture-growth-phase/CreateGrowthPhaseItemCard'
import GrowthPhaseItems from '../../components/culture-growth-phase/GrowthPhaseItems'

export default {
    name: 'CultureGrowthPhaseItemsView',
    components: {
        'create-growth-phase-item-card': CreateGrowthPhaseItemCard,
        'growth-phase-items': GrowthPhaseItems,
    },
    computed: {
        ...mapState('cultureGrowthPhase', ['selectedGrowthPhase']),
        phaseId() {
            return parseInt(this.$route.params.phaseId)
        },
    },
    methods: {
        goBack() {
            this.$router.push({ name: 'culture-growth-phase' })
        },
    },
}
</script>

<style scoped>
</style>
